import styled from "styled-components"

const DescriptionImageStyled = styled.div`
  display: flex;
  padding-bottom: 70px;
  @media (max-width: 880px) {
    flex-wrap: wrap;
    padding-bottom: 70px;
  }
  h2 {
    position: relative;
    &:before {
      content: "";
      display: block;
      width: 13vw;
      height: 1px;
      background: #333333;
      position: absolute;
      margin: 0;
      top: 27%;
      transform: translateY(-50%);
      left: 93%;
      @media (max-width: 880px) {
        content: unset;
      }
    }
  }
  .half__wrapper {
    width: 50%;
    min-height: 460px;
    @media (max-width: 880px) {
      width: 100%;
      min-height: 330px;
    }
  }
  .descrption {
    text-align: center;
    font-size: 18px;
    font-weight: 300;
    max-width: 460px;
    margin: 0 auto;
  }
  .half__content--left {
    padding-right: 4vw;
    margin-left: auto;
    display: flex;
    height: 100%;
    padding-bottom: 100px;
  }
  .half__content {
    max-width: 590px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width: 1280px) {
      max-width: 500px;
    }
    @media (max-width: 1080px) {
      max-width: 400px;
    }
    @media (max-width: 880px) {
      max-width: 100%;
      padding: 0 40px;
    }
    @media (max-width: 680px) {
      padding: 0 20px;
    }
  }
  .half__content--right {
    background: url(${props => props.image});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 100%;
    margin-left: auto;
    max-width: initial;
  }
`

export default DescriptionImageStyled
